export enum MicrofrontendType {
    appointment = 'appointment',
    protocol = 'protocol',
    protocolConstructor = 'protocol-constructor',
}
